import React, { Fragment } from "react";
import { withRouter, Link } from "react-router-dom";

import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

import Select from "@material-ui/core/Select";

import { cartAdd } from "../../actions/cart";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StarRatings from "react-star-ratings";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { CallMerge } from "@material-ui/icons";

class Wishlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      products: [],
      totalItems: "",
      selectVal: "",
    };
  }
  // card style
  cardStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };

  async componentDidMount() {
    const wishlist = localStorage.getItem("wishlist");
    if (wishlist && wishlist.length > 0) {
      await this.setState({ products: JSON.parse(wishlist) });
    }
  }

  _addToCart = async (item) => {
    const data = {
      item: item,
      quantity: 1,
    };
    const cartAdd = await this.props.cartAdd(data);
    if (cartAdd) {
      toast(`Product added in cart`, { containerId: "B" });
    }
  };

  _removeWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          arr.splice(index, 1);
          localStorage.setItem("wishlist", JSON.stringify(arr));
          toast(`Product removed from wishlist`, { containerId: "B" });
          this.setState({
            products: JSON.parse(localStorage.getItem("wishlist")),
          });
        }
      });
    }
  };
  _openModal = async (e, item) => {
    e.preventDefault();
    const productsArr = [];
    // item &&
    //   item.forEach(async __element => {
    //     productsArr.push(__element);
    //   });
    // console.log("product array ", item);
    await this.setState({ quickView: item });
    const images = [];

    item.images.forEach((e) => {
      images.push({
        original: e,
        thumbnail: e,
      });
    });
    this.setState({ images: images });

    this.setState({ show: true });
  };
  changeSelect = (e) => {
    this.setState({
      selectVal: e.target.value,
    });
  };
  handleLowPrice = (favItems) => {
    favItems.sort((low, high) => low.price - high.price);
  };
  handleHighPrice = (favItems) => {
    favItems.sort((low, high) => high.price - low.price);
  };
  handleDate = (favItems) => {
    favItems.map((favItem) => {
      console.log(favItem);
      console.log(favItem.createdAt);
    });
  };
  render() {
    const { products } = this.state;

    return (
      <Fragment>
        <ToastContainer
          enableMultiContainer
          containerId={"B"}
          position={toast.POSITION.TOP_RIGHT}
        />
        <div className="wishlist-wrapper wrapper-90 max-1600">
          <BreadCrumb title={`Account / My Wish List`} />
          <div className="container-fluid">
            <div className="my-wish-list">
              <h3>My Wish List</h3>
              <div className="d-flex align-items-center justify-content-between flex-wraped">
                <div className="d-flex align-items-center">
                  <p className="mb-0"> {products && products.length} Items</p>
                  <p className="d-flex align-items-center mb-0 ml-3">
                    <span>
                      <svg className="lockIcon" viewBox="0 0 28 28">
                        <path d="M20 10h-2a4 4 0 1 0-8 0H8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-6-2a2 2 0 0 1 2 2h-4a2 2 0 0 1 2-2zm5 12H9v-8h10v8z"></path>
                        <path d="M14 13.5a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1z"></path>
                      </svg>
                    </span>
                    Private
                  </p>
                </div>
                <div className="wishList-dropDown">
                  <InputLabel id="label">Sort By</InputLabel>
                  <Select
                    labelId="label"
                    id="select"
                    value={this.state.selectVal ? this.state.selectVal : ""}
                    onChange={this.changeSelect}
                  >
                    <MenuItem
                      onClick={() => {
                        this.handleDate(products && products);
                      }}
                    >
                      Date added
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.handleLowPrice(products && products);
                      }}
                      value="Price per item: Low-High"
                    >
                      Price per item: Low-High
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.handleHighPrice(products && products);
                      }}
                      value="Price per item: High-Low"
                    >
                      Price per item: High-Low
                    </MenuItem>
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              {products.length > 0 &&
                products.map((item, index) => (
                  <>
                    <div
                      key={index}
                      className="col-md-3 my-3 col-sm-6 col-12 borderBottom-1"
                    >
                      <div className="product-cards" style={this.cardStyle}>
                        <Link to={`/product/${item.slug}`}>
                          <div className="product-cards-img">
                            <div
                              style={{
                                backgroundImage: `url(${
                                  item.mainImage && item.mainImage
                                })`,
                                backgroundSize: "contain",
                                height: "100%",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                              }}
                            ></div>
                            {/* <img src={`${item.images[0]}`} width="100%" alt="" /> */}
                          </div>
                        </Link>
                        <div className="card-inner-area">
                          <span className="sale-sticker">
                            {item.outOfStock === false
                              ? "In Stock"
                              : "Out of Stock"}
                          </span>
                          <span
                            className="sale-wish wishlist"
                            title="delete this"
                            onClick={() => {
                              this._removeWishlist(item);
                            }}
                          >
                            <i className="far fa-heart" />
                          </span>
                          <div className="quick-view-btn">
                            <Link
                              to={"!#"}
                              onClick={(e) => this._openModal(e, item)}
                            >
                              <span>Quickview</span>
                            </Link>
                          </div>
                        </div>{" "}
                        <div className="d-flex justify-content-between flex-column">
                          <div className="product-cards-content">
                            <div className="product-cards-txt">
                              <div className="row">
                                {item.grouping &&
                                  item.grouping.length > 0 &&
                                  item.grouping
                                    .slice(0, 5)
                                    .map((group, indx) => (
                                      <div
                                        className="col-md-2 col-sm-2 col-2"
                                        style={{
                                          flex: "0 0 14.666667%",
                                          maxWidth: "14.666667%",
                                        }}
                                        key={indx}
                                      >
                                        <Link
                                          to={`/product/${group.slug}`}
                                          style={{
                                            border: "1px solid #e1e1e1",
                                            borderRadius: "7px",
                                            marginTop: "4px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              backgroundImage: `url(${
                                                group &&
                                                group.images &&
                                                group.images[0]
                                              })`,
                                              backgroundSize: "contain",
                                              height: "30px",
                                              backgroundRepeat: "no-repeat",
                                              backgroundPosition: "center",
                                              width: "100%",
                                              padding: "2px",
                                            }}
                                          ></div>
                                          {/* <img
                                src={group && group.images[0]}
                                alt={group && group.title}
                                style={{
                                  border: "1px solid gray",
                                  borderRadius: "7px",
                                  width: "100%",
                                  marginTop: "4px",
                                }}
                              /> */}
                                        </Link>
                                      </div>
                                    ))}
                                {item.grouping && item.grouping.length > 4 && (
                                  <div className="col-md-2 col-sm-2 col-2">
                                    <Link
                                      to={`/product/${item.slug}`}
                                      className="grouping-left"
                                    >
                                      <div
                                        style={{
                                          height: "30px",
                                          width: "100%",
                                          border: "1px solid #e1e1e1",
                                          borderRadius: "7px",
                                          marginTop: "4px",
                                          paddingTop: "2px",
                                          textAlign: "center",
                                          background: "#ecedef",
                                        }}
                                      >
                                        {item.grouping.length - 4}+
                                      </div>
                                    </Link>
                                  </div>
                                )}
                              </div>
                              <Link to={`/product/${item.slug}`}>
                                {item && item.title}
                              </Link>
                              <div className="product-cards-price">
                                <span>
                                  $
                                  {item.enableSale === true
                                    ? Number(
                                        item.price -
                                          (item.price * item.saleDiscount) / 100
                                      ).toFixed(2)
                                    : Number(item.price).toFixed(2)}
                                </span>
                                <span>
                                  {item.enableSale === true ? (
                                    <del>${Number(item.price).toFixed(2)}</del>
                                  ) : null}
                                </span>
                              </div>
                              <div className="product-cards-rating">
                                <ul className="product-rating">
                                  <StarRatings
                                    rating={
                                      item.reviews
                                        ? item.reviews / item.reviewCount
                                        : 0
                                    }
                                    starDimension="20px"
                                    starSpacing="2px"
                                    starRatedColor="gold"
                                  />
                                  <span>{item.reviewCount}</span>
                                </ul>
                                <span className="affirm-text ">
                                  <p
                                    className="affirm-as-low-as"
                                    data-page-type="category"
                                    data-amount={`${item && item.price * 100}`}
                                  ></p>
                                </span>

                                <span>
                                  {item.price > 49 ? (
                                    <b>Free Shipping</b>
                                  ) : (
                                    <b></b>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="add-cart text-center">
                            <button
                              className="add-myCart"
                              onClick={() => {
                                this._addToCart(item && item);
                              }}
                            >
                              <span>
                                <i className="fas fa-cart-plus" />
                                &nbsp; Add
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              {products.length === 0 ? (
                <div className="col-md-12">
                  <tr>
                    <td
                      colSpan="6"
                      style={{ textAlign: "center", color: "#17a2b8" }}
                    >
                      Whishlist is empty
                    </td>
                  </tr>
                </div>
              ) : null}
              {/* <div className="table-responsive wish-list-table">
                <table className="table">
                  <thead>
                    <tr className="whishlist-row-header">
                      <th className="text-center">
                        <span>Image</span>
                      </th>
                      <th className="text-center">
                        <span>Product Name</span>
                      </th>
                      <th className="text-center">
                        <span>Model</span>
                      </th>
                      <th className="text-center">
                        <span>Stock</span>
                      </th>
                      <th className="text-center">
                        <span>Unit Price</span>
                      </th>
                      <th className="text-center">
                        <span>Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="wish-table-body">
                    {products.length > 0 &&
                      products.map((item, index) => (
                        <tr key={index} className="wish-table-row">
                          <td className="wish-column">
                            <div className="wish-list-img">
                              <img
                                src={item.images && item.images[0]}
                                width="90px"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="wish-column wish-product-name">
                            <Link to={`/product/${item.slug}`}>
                              {item && item.title}
                            </Link>
                          </td>
                          <td className="wish-column">{item.model}</td>
                          <td className="wish-column">
                            {" "}
                            {item.outOfStock === false
                              ? "In Stock"
                              : "Out of Stock"}
                          </td>
                          <td className="wish-column">${item.price}.00</td>
                          <td className="wish-column">
                            <div className="add-dlt-wish">
                              <span
                                className="add-wish-toCart"
                                title="Add to cart"
                                onClick={() => {
                                  this._addToCart(item);
                                }}
                              >
                                <i className="fas fa-shopping-cart" />
                              </span>
                              <span
                                className="delete-wish"
                                title="delete this"
                                onClick={() => {
                                  this._removeWishlist(item);
                                }}
                              >
                                ×
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    {products.length === 0 ? (
                      <tr>
                        <td
                          colSpan="6"
                          style={{ textAlign: "center", color: "#17a2b8" }}
                        >
                          Whishlist is empty
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div> */}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};

export default withRouter(connect(null, { cartAdd })(Wishlist));
